// Placeholder Sidebar component for POS system
const Sidebar = ({ isOpen, onToggle }) => {
  return null; // POS system doesn't use sidebar
};

export default Sidebar;

